export enum SlideStates {
    CLOSE = 'close',
    OPEN = 'open',
    LATERAL_CLOSE = 'lateral-close',
    LATERAL_OPEN = 'lateral-open'
}
export enum CSSDisplay {
    Inline = 'inline',
    Block = 'block',
    Contents = 'contents',
    Flex = 'flex',
    Grid = 'grid',
    Inline_block = 'inline-block',
    Inline_flex = 'inline-flex',
    Inline_grid = 'inline-grid',
    Inlinte_table = 'inline-table',
    List_item = 'list-item',
    Run_in = 'run-in',
    Table = 'table',
    Table_caption = 'table-caption',
    Table_column_group = 'table-column-group',
    Table_header_group = 'table-header-group',
    Table_footer_group = 'table-footer-group',
    Table_row_group = 'table-row-group',
    Table_cell = 'table-cell',
    Table_column = 'table-column',
    Table_row = 'table-row',
    None = 'none',
    Initial = 'initial',
    Inherit = 'inherit'
}
export interface CSSAnimationFunctions {
    Linear: number;
    Ease: string;
    Ease_in: string;
    Ease_out: string;
    Ease_in_out: string;
    Step_start: string;
    Step_end: string;
    Initial: string;
    Inherit: string;
    Steps(int: any, start_end: any): string;
    cubic_bezier(n: any, n2: any, n3: any, n4: any): string;
}
export class CSSAnimationFunctions implements CSSAnimationFunctions {
    public static Linear = 'linear'; // The animation has the same speed from start to end
    public static Ease = 'ease'; // The animation has a slow start, then fast, before it ends slowly
    public static Ease_in = 'ease-in'; // The animation has a slow start
    public static Ease_out = 'ease-out'; // The animation has a slow end
    public static Ease_in_out = 'ease-in-out'; // The animation has a slow end
    public static Step_start = 'step-start'; // Equivalent to steps(1, start)
    public static Step_end = 'step-end'; // Equivalent to steps(1, end)
    public static Initial = 'initial'; // Sets this property to its default value
    public static Inherit = 'inherit'; // Inherits this property from its parent element

    // Specifies a stepping function, with two parameters. The first parameter specifies the number of intervals in the function.
    // It must be a positive integer (greater than 0). The second parameter, which is optional, is either the value "start" or "end",
    // and specifies the point at which the change of 
    // values occur within the interval. If the second parameter is omitted, it is given the value "end"
    public static Steps(int: number, start_end: string): string {
        return `steps(${int}, ${start_end})`;
    }
    // Define your own values in the cubic-bezier function
    // Possible values are numeric values from 0 to 1
    public static cubic_bezier(n: number, n2: number, n3: number, n4: number) {
        return `cubic-bezier(${n}, ${n2}, ${n3}, ${n4})`;
    }

}
export interface SlideAnimationConfig {
    time: number; // tiempo transicion (segundos)
    function: string; // animation timing-function
}
export interface SlideConfig {
    animationConfig: SlideAnimationConfig;
    contentDisplay: CSSDisplay;
}
  